import {FC} from 'react'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {brandName} from '../../../_metronic/helpers'

/** «پشتیبانی …»; compact: a box in the dashboard's side column, its button under the text. */
const DashboardTicketAnnouncement: FC<{compact?: boolean}> = ({compact}) => (
  <section
    className={clsx('mp-ticket-announcement', {'mp-ticket-announcement--compact': compact})}
    aria-labelledby='dashboard-ticket-announcement-title'
  >
    <span className='mp-ticket-announcement__icon' aria-hidden='true'>
      <i className='las la-headset' />
    </span>

    <div className='mp-ticket-announcement__content'>
      <span>پشتیبانی {brandName}</span>
      <h2 id='dashboard-ticket-announcement-title'>پشتیبانی سریع‌تر، پیگیری ساده‌تر</h2>
      <p>
        برای هر سؤال، خطا یا درخواست، یک تیکت ثبت کنید؛ پیام‌ها، فایل‌ها و وضعیت رسیدگی یک‌جا
        می‌مانند تا پاسخ را سریع‌تر دریافت کنید و هیچ پیگیری‌ای از دست نرود.
      </p>
    </div>

    <Link
      className='btn btn-primary mp-ticket-announcement__action'
      to='/apps/ticket-management/new'
    >
      <i className='las la-plus-circle' aria-hidden='true' />
      ثبت تیکت پشتیبانی
    </Link>
  </section>
)

export {DashboardTicketAnnouncement}
